import { render, staticRenderFns } from "./IconTable.vue?vue&type=template&id=ec1d9f58&scoped=true&"
import script from "./IconTable.vue?vue&type=script&lang=js&"
export * from "./IconTable.vue?vue&type=script&lang=js&"
import style0 from "./IconTable.vue?vue&type=style&index=0&id=ec1d9f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d9f58",
  null
  
)

export default component.exports